import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';
import { Colors, Fonts } from '../utils/colors';
import { TerminalGhostButton } from './TerminalButton';

export const QrCodeButton = (props: {padLink: string}) => {
  const [showQrCode, setShowQrCode] = useState(false)
  const [isQrLoaded, setQrLoaded] = useState(false)
  const padLink = props.padLink
  const imgLink = `https://api.qrserver.com/v1/create-qr-code/?data=${padLink}&size=200x200`

  const handleClose = () => {
    setShowQrCode(false)
  }

  var progressBar = <div/>
  if (!isQrLoaded) {
    progressBar = (
      <ProgressContainer>
        <CircularProgress color="primary" />
      </ProgressContainer>
    )
  }

  var qrCodeDialog = <div/>
  if (showQrCode) {
    qrCodeDialog = (
      <Dialog
        open={showQrCode}
        onClose={handleClose}
        maxWidth={false}
        PaperProps={{
          style: {
            background: Colors.terminalPanel,
            margin: 16,
            width: "auto",
          },
        }}
      >
        <DialogContainer>
          <DialogTitle>qr code</DialogTitle>
          <QrContainer>
            {progressBar}
            <img src={imgLink} alt="QR code" onLoad={() => setQrLoaded(true)} />
          </QrContainer>
        </DialogContainer>
      </Dialog>
    )
  }

  return (
    <div>
      <TerminalGhostButton type="button" onClick={() => setShowQrCode(true)}>
        qr
      </TerminalGhostButton>
      {qrCodeDialog}
    </div>
  )
}

const ProgressContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const QrContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  margin: 0 auto;

  img {
    display: block;
    width: 200px;
    height: 200px;
  }
`;

const DialogContainer = styled.div`
  width: 240px;
  padding: 20px;
  background: ${Colors.terminalPanel};
  box-sizing: border-box;
`;

const DialogTitle = styled.div`
  margin-bottom: 12px;
  color: ${Colors.destructGreen};
  font-family: ${Fonts.mono};
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-align: center;
`;
